import styled from 'styled-components'

export const MBRItemContainer = styled.div`
  width: 100%;
  max-width: 1200px;
  margin: 10px auto;
  background: linear-gradient(45deg, #193d46, #6e92a2, #6c7f48);
  border-radius: 8px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 40px 20px;
  @media (min-width: 768px) {
    padding: 40px;
  }
`

export const MBRItemInternalContainer = styled.div`
  background: #fff;
  border-radius: 8px;
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 16px;
  width: 350px;
  position: relative;
`

export const MBRItemLogoImage = styled.div`
  width: 40px;
  height: 40px;
  border-radius: 50%;
  border: 2px solid #fff;
  position: absolute;
  top: -20px;
  background: url(${(props) => props.bglink});
  background-size: cover;
`

export const MBRActionbuttonContainer = styled.div`
  display: flex;
  justify-content: center;
  gap: 16px;
  position: absolute;
  bottom: -25px;
  @media (min-width: 768px) {
    gap: 48px;
  }
`

export const MBRActionbutton = styled.button`
  width: 50px;
  height: 50px;
  border-radius: 16px;
  border: ${(props) => (props?.successStyle ? '1px solid #2BAF41' : '1px solid #FF0000')};
  display: flex;
  justify-content: center;
  align-items: center;
  background: ${(props) => (props?.successStyle ? '#2BAF41' : '#FFF')};
`
